import React from 'react';

class Timeout extends React.Component {
    render() {

        return <div>
            <div className="d-xl-none">
                <div className={this.props.type + ' padding-bottom-20'}><a className={'warningMessage'} href="/innsyn/login">Sesjonen er utløpt,<br/>trykk <span className={'timeoutLink'}>her</span> for å logge inn på nytt</a></div>
            </div>
            <div className="d-none d-xl-block">
                <div className={this.props.type + ' padding-bottom-20'}><a className={'warningMessage'} href="/innsyn/login">Sesjonen er utløpt, trykk <span className={'timeoutLink'}>her</span> for å logge inn på nytt</a></div>
            </div>
            </div>
    }
}

export default Timeout;